import { Button } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useClearRefinements } from 'react-instantsearch'
import { useRefinementsConfig } from '../hooks/useRefinementsConfig'
import { CustomRangeRefinement } from './CustomRangeRefinement'
import { CustomRefinementList } from './CustomRefinementList'
import { RefinementWrapper } from './RefinementWrapper'

type SearchRefinementsProps = {
  showClearButton?: boolean
}

export function SearchRefinements({
  showClearButton = false,
}: SearchRefinementsProps) {
  const { refine: clearRefinements, hasRefinements } = useClearRefinements()
  const t = useTranslations('SearchRefinements')
  const { lists, ranges } = useRefinementsConfig()

  return (
    <div className="flex flex-col">
      {lists.map((refinement) => (
        <RefinementWrapper
          key={refinement.attribute}
          refinement={refinement}
          Component={CustomRefinementList}
        />
      ))}
      {ranges.map((refinement) => (
        <RefinementWrapper
          key={refinement.attribute}
          refinement={refinement}
          Component={CustomRangeRefinement}
        />
      ))}
      {showClearButton && hasRefinements && (
        <div className="border-t border-lines py-2">
          <Button
            variant="text"
            onClick={() => clearRefinements()}
            className="self-start"
            classes={{
              root: 'px-0 normal-case text-base font-medium',
            }}
            disableRipple
          >
            {t('clear_all_filters')}
          </Button>
        </div>
      )}
    </div>
  )
}
